module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "addcreditSection"
    }
  }, [_c('div', {
    staticClass: "content bg-blue-grey-100 p-30"
  }, [_c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n      กรุณาเติมเงินผ่านช่องทาง\n      "), _c('a', {
    attrs: {
      "href": "https://www.byteark.com/payment/"
    }
  }, [_vm._v("https://www.byteark.com/payment/")]), _vm._v("\n      โดยคุณสามารถโอนเงินชำระตามจำนวนที่ต้องการ และแจ้งโอนเงินพร้อมหลักฐานการโอนเงินมาที่ "), _c('a', {
    attrs: {
      "href": "mailto:support@byteark.com"
    }
  }, [_vm._v("support@byteark.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d516d862!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/billings/payments/BillingCreditDirect.vue
// module id = 560
// module chunks = 1